import {LocalStyleSheet} from '../utils/types'
import {Color} from './custom/colors'

const containerStyle = {
    backgroundColor: Color.neutral5,
    padding: 10,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: Color.neutral3,
    display: 'flex',
    alignItems: 'center'
}
const columnStyle = {
    display: 'flex',
    flexDirection: 'column' as const
}

const inlineStyle = {
    display: 'flex',
    flexDirection: 'row' as const
}

const flex1 = {
    display: 'flex',
    flex: 1
}

export const sharedStyles: LocalStyleSheet = {
    container: {
        ...containerStyle
    },
    inlineContainer: {
        ...inlineStyle,
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    sectionWrapper: {
        ...containerStyle,
        flexDirection: 'column',
        alignItems: 'start',
        width: '49.5%'
    },
    lightSectionWrapper: {
        backgroundColor: Color.lightPurple,
        padding: 10,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: Color.active,
    },
    column: {
        ...columnStyle
    },
    inline: {
        ...inlineStyle
    },
    border: {
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: Color.warningStrong
    },
    divider: {
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: Color.neutral3
    },

    leftColumn: {
        ...columnStyle,
        flex: 1,
        marginRight: 5,
        maxWidth: '49%'
    },
    rightColumn: {
        ...columnStyle,
        flex: 1,
        marginLeft: 5,
        maxWidth: '49%'
    },
    oneColumn: {
        ...columnStyle,
        flex: 1,
        marginLeft: 5,
        maxWidth: '100%'
    },
    oneThirdColumn: {
        ...columnStyle,
        flex: 1,
        marginLeft: 5,
        maxWidth: '32%'
    },
    actionBtnLeft: {
        ...flex1
    },
    actionBtnRight: {
        ...flex1,
        justifyContent: 'flex-end'
    },

    checkbox: {
        ...inlineStyle,
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '3%'
    },

    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}
